import { downloadFirmwareMappings } from '$lib/api/rcu_mappings';
import { router } from '$lib/router/router.svelte';
import { showSuccess } from '$lib/state/toast.svelte';
import { clearError, setError, uiState } from '$lib/state/ui.svelte';

export async function downloadMappings(format: string) {
	const unitId = router.unitId;
	if (!unitId) {
		setError('Please select a unit first');
		return;
	}

	uiState.isExporting = true;
	clearError();

	try {
		await downloadFirmwareMappings(unitId, format);
		showSuccess(`Successfully exported ${format} mappings`);
	} catch (error) {
		const message = error instanceof Error ? error.message : 'Export failed. Please try again.';
		setError(message);
	} finally {
		uiState.isExporting = false;
	}
}

export async function downloadAllFormats() {
	await downloadMappings('all');
}
